import React from 'react';
import { CheckIcon } from 'lucide-react';
import { usos } from '../data/landing';
export function UsesSection() {
  return <section className="w-full bg-ink-800 px-4 py-9 text-cream sm:px-8 sm:py-14" data-id="element-187" data-mp="37bvfkgftlc74">
      <div className="mx-auto max-w-6xl" data-id="element-188" data-mp="2semj58bnti8j">
        <h2 className="max-w-3xl font-display text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-189" data-mp="2sfxqfi4bd84e">
          Un solo Mega Pack. Cientos de posibilidades para tu aula.
        </h2>

        <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 sm:mt-6 sm:grid-cols-3 lg:grid-cols-4" data-id="element-190" data-mp="3l30m82hlv4qy">
          {usos.map(uso => <li key={uso} className="flex items-center gap-1.5 font-sans text-xs text-cream-200 sm:text-sm" data-id="element-191" data-mp="3q3fzyv5sue9g">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-192" data-mp="3gah894f0a7lm" />
              {uso}
            </li>)}
        </ul>

        <p className="mt-5 max-w-3xl font-sans text-sm text-cream-200/90 sm:mt-7 sm:text-base" data-id="element-193" data-mp="cngwhdg584gn">
          No necesitás utilizar todo de una vez: tenés una biblioteca completa
          para elegir el recurso que necesitás en cada momento.
        </p>
      </div>
    </section>;
}